Ext.define('SA.SessionStorage', {
    singleton: true,

    clear() {
        sessionStorage.clear();
    },

    get(key) {
        return sessionStorage.getItem(key);
    },

    set(key, value) {
        sessionStorage.setItem(key, value);
    }
});